export default {
  computed: {
    bookmarkCount() {
      if (!this.isLoggedIn) {
        return undefined;
      }

      if (this.$route.meta.showJobBookmarksMobileButton) {
        return this.getNumbers('job').bookmarks;
      }

      if (this.$route.meta.showHeadhunterBookmarksMobileButton) {
        return this.getNumbers('headhunter').bookmarks;
      }

      return undefined;
    },
  },
  methods: {
    handleBookmarkClick() {
      if (this.$route.meta.showJobBookmarksMobileButton) {
        this.handleBookmarkJobClick();
      }

      if (this.$route.meta.showHeadhunterBookmarksMobileButton) {
        this.handleBookmarkHeadhunterClick();
      }
    },
    handleBookmarkJobClick() {
      if (this.$route.name.startsWith('search-jobs') && this.$route.query.view === 'bookmarked') {
        const { view, ...queryWithoutView } = this.$route.query;
        this.$router.push({
          name: this.$route.name,
          query: queryWithoutView,
        });
        return;
      }

      this.$router.push({
        name: 'search-jobs',
        query: {
          view: 'bookmarked',
        },
      });
    },
    handleBookmarkHeadhunterClick() {
      if (this.$route.name === 'search-headhunter' && this.$route.query.view === 'bookmarked') {
        const { view, ...queryWithoutView } = this.$route.query;
        this.$router.push({
          name: this.$route.name,
          query: queryWithoutView,
        });
        return;
      }

      this.$router.push({
        name: 'search-headhunter',
        query: {
          view: 'bookmarked',
        },
      });
    },
  }
}